


























import Vue from "vue";
import { aisleCategoryService } from "@/aisle-category/services/AisleCategoryService";
import { AisleCategory } from "@/aisle-category/models/AisleCategory";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";

export default Vue.extend({
  name: "AisleCategoryEdit",
  props: {
    add: {
      type: Boolean,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
    },
    aisleCategoryId: {
      type: Number,
      default: undefined,
      required: false,
    },
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t("modules.common.breadcrumbs.home"),
          to: "/",
        },
        {
          text: this.$t("modules.common.breadcrumbs.aisle-category"),
          to: RouteInfoMap.get(Paths.AisleCategory)?.path,
          exact: true,
        },
        {
          text: this.add ? this.$t("modules.common.breadcrumbs.add") : `${this.aisleCategoryId}`,
          disabled: true,
        },
      ],
      loading: false,
      submitLoading: false,
      valid: true,
      aisleCategory: new AisleCategory(""),
      image: undefined as File | undefined,
      nameRules: [
        (v: string): boolean | string => !!v || this.$t("modules.aisle-category.edit-dialog.name-required").toString(),
        (v: string): boolean | string =>
          !(v && v.trim().length === 0) || this.$t("modules.aisle-category.edit-dialog.name-not-blank").toString(),
      ],
    };
  },
  async mounted() {
    if (this.edit) {
      this.loading = true;
      try {
        this.aisleCategory = await aisleCategoryService.getAisleCategory(this.aisleCategoryId);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    }
  },
  methods: {
    validate(): void {
      (this.$refs.form as Vue & { validate: () => boolean }).validate();
    },
    submit(): void {
      this.validate();
      if (this.valid) {
        if (this.edit) {
          this.updateAisleCategory();
        } else {
          this.createAisleCategory();
        }
      }
    },
    async createAisleCategory(): Promise<void> {
      this.submitLoading = true;
      try {
        await aisleCategoryService.createAisleCategory(
          this.aisleCategory.name,
          this.aisleCategory.description,
          this.image
        );
        await this.$router.push({
          name: RouteInfoMap.get(Paths.AisleCategory)?.name,
        });
      } catch (e) {
        console.error(e);
        this.submitLoading = false;
      }
    },
    async updateAisleCategory(): Promise<void> {
      this.submitLoading = true;
      try {
        this.aisleCategory = await aisleCategoryService.updateAisleCategory(
          this.aisleCategoryId,
          this.aisleCategory.name,
          this.aisleCategory.description,
          this.image
        );
        this.image = undefined;
      } catch (e) {
        console.error(e);
      }
      this.submitLoading = false;
    },
  },
});
